import { filter } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  styled,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { useClientContext } from '../../../context/client_context';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'billNo', label: 'Ref ID', alignRight: true },
  { id: 'billDate', label: 'Date', alignRight: false },
  { id: 'description', label: 'Account', alignRight: false },
  //   { id: 'terms', label: 'Supplier', alignRight: false },
  { id: 'revenue', label: 'Details', alignRight: false },
  //   { id: 'creaetd', label: 'Subtotal', alignRight: true },
  //   { id: 'posted', label: 'VAT', alignRight: true },
  { id: 'users', label: 'Amount Paid', alignRight: true },
  { id: 'as', label: 'Method' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function BillsList() {
  const { setClientRefId } = useClientContext();
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docType, setDocType] = useState('pdf');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const filename = `Bills_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  console.log('begDate in useEffect 123', begDate);
  useEffect(() => {
    // getExtraPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const GetExpenditures = () => {
    fetch(
      `${baseUrl}/api/accounting/GetExpendituresRpt?begDate=${moment(begDate).format(
        'YYYY-MM-DD'
      )}&endDate=${moment(endDate).format('YYYY-MM-DD')}`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned GetExpenditures list', result.result);
          setDataList(result.result);
        },
        (error) => {
          notifyPopup(`Error in GetExpenditures!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/report/get/ExpenditureRpt/${docType}/${moment(begDate).format(
        'YYYY-MM-DD'
      )}/${moment(endDate).format('YYYY-MM-DD')}/0/0/0/0`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Claims by Department!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const getPaymentType = (e) => {
    switch (e.paymentMethod) {
      case 807100:
        return 'Cash';
      case 807200:
        return 'Cheque';
      case 807300:
        return 'Bank Transfer';
      default:
        return 'Cash';
    }
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={5} sm={4}>
          <Typography component="span" variant="h4" gutterBottom>
            Claim Payments Report
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              size="small"
              value={docType}
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              value={begDate}
              size="small"
              onChange={(e) => {
                setBegDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date"
              // inputFormat="dd/MM/yyyy"
              value={endDate}
              size="small"
              onChange={(e) => {
                setEndDate(e);
              }}
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => GetExpenditures()}
          >
            Refresh
          </Button>
        </Grid>
        {/* <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Export
          </Button>
        </Grid> */}
      </Grid>

      <Divider style={{ background: '#9c27b0', height: 2, margin: 10 }} variant="middle" />

      <Card>
        {/* <Scrollbar> */}
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              // onSelectAllClick={handleSelectAllClick}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const {
                    refId,
                    paymentDate,
                    accountName,
                    receipient,
                    paymentDetails,
                    supplierInvNo,
                    subAmount,
                    vatPaid,
                    paymentMethod,
                    amountPaid
                  } = row;
                  const isItemSelected = selected.indexOf(refId) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={refId}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />

                      <TableCell align="right">{refId}</TableCell>
                      <TableCell component="th" scope="row" padding="none">
                        {moment(paymentDate).isValid()
                          ? moment(paymentDate).format('YYYY-MM-DD')
                          : ''}
                      </TableCell>
                      <TableCell align="left">{accountName}</TableCell>
                      {/* <TableCell align="left">{receipient}</TableCell> */}
                      <TableCell align="left">{paymentDetails}</TableCell>
                      {/* <TableCell align="right">{subAmount.toFixed(2)}</TableCell>
                      <TableCell align="right">{vatPaid.toFixed(2)}</TableCell> */}
                      <TableCell align="right">{amountPaid.toFixed(2)}</TableCell>
                      <TableCell align="left">{getPaymentType({ paymentMethod })}</TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isListEmpty && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        {/* </Scrollbar> */}

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
